import { IStandardAutocomplete } from "../../_common/interface/autocomplete/iStandardAutocomplete";
import { emailtemplateService } from "../../_services/emailTemplate.service";
import { usersService } from "../../_services/users.service";
import StandardAutoComplete from "./standard.autocomplete";

interface IStandardExtAutocomplete extends IStandardAutocomplete {
}

export const AdminUserAutoComplete = (params: IStandardExtAutocomplete) => {

    return (
        <StandardAutoComplete
            {...params}
            itemsLoader={usersService.getAdmins}
            label={"Select User"} />
    );
}